import { Inject } from 'inversify-props';
import type { MetaDiariaServiceAdapter } from './adapter';
import { MetaDiaria } from '@/models/MetaDiaria';
import type { MetaDiariaBatchItem } from '@/api/metaDiaria';

const ERRO_NA_REQUISICAO = 'Erro ao salvar Meta'

export class SaveMetaDiariaUseCase {
	@Inject("MetaDiariaServiceAdapter")
	private metaService!: MetaDiariaServiceAdapter

	async update(meta: MetaDiaria): Promise<MetaDiaria> {
		try {
			if (meta.id) {
				const metaResponse = await this.metaService.update(meta)
				if (metaResponse) {
					return metaResponse
				} 
				throw new Error(metaResponse)
			} else {
				const metaResponse = await this.metaService.create(meta)
				if (metaResponse) {
					return metaResponse
				}
				throw new Error(metaResponse)
			}
		} catch (e: any) {
			throw new Error(`${ERRO_NA_REQUISICAO}: ${e.response.data[0]}`)
		}
	}

	async importarMetasDiarias(metaId: string, mes: number, ano: number, urlDoArquivo: string): Promise<void>{
		return this.metaService.importarMetasDiarias(metaId, mes, ano, urlDoArquivo)
	}

	async salvarBatch(itens: MetaDiariaBatchItem[]): Promise<{ salvos: number }> {
		return this.metaService.salvarBatch(itens)
	}

}